import { FC } from 'react'
import { Typography } from '@mui/material'

import { renderNutritionSidebar } from '@/apps/latest/features/nutrition/nutritionShell'
import { Layout } from '@/apps/latest/components/templates/Layout'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'

// 管理栄養士のホーム (/nutrition)。人を引く・登録するのは左ペイン (お客様の司令塔) なので、本文は 1 行だけ
// (最後に開いたカルテは出さない — 共有の PC で前の人のカルテが見える。design-book ADR-0086)。
const NutritionHomePage: FC = () => (
  <Layout breadcrumb={['お客様']} renderSidebar={renderNutritionSidebar}>
    <Typography variant="body2" sx={{ color: colorTokens.fg.muted }}>
      左の一覧からお客様を選ぶか、新しいお客様を登録します。
    </Typography>
  </Layout>
)

export default NutritionHomePage
